import { ReactElement, useMemo, useRef } from 'react'
import {
  RocketScienceSection,
  WebsiteLayout,
  EmpowerSection,
  useUpdateHeader,
  HEADER_THEMES,
  ForTalentsGetStarted,
  ExpandYourConnections,
  useCleanHeader,
  FromOurBlogSection,
  TalentNewsletterSections,
  ReadyToSayHelloTalentSection,
  WebsiteSeo,
  SayHelloSection,
  LifeChangingOpportunities,
  ForTalentOlbySpace,
  ForTalentTransparencyUnfolded,
} from '@platform/website-components'
import { Locale, useGetWebsiteTalentPageQuery } from '@platform/data-access'
import { websiteFormatArticleList } from '@platform/utils'

import styles from './styles.module.scss'

const SEO = {
  title: 'For Talent // Olby',
  description:
    'Olby empowers you to thrive: long-term meaning work for international companies. Begin your journey toward the next level of your career.',
}

export const ForTalent = () => {
  const empowerRef = useRef<HTMLElement>(null)
  const getStartedRef = useRef<HTMLDivElement>(null)
  const lifeChangingRef = useRef<HTMLDivElement>(null)
  const sayHelloRef = useRef<HTMLDivElement>(null)
  const rocketScienceRef = useRef<HTMLDivElement>(null)
  const transparencyUnfoldedRef = useRef<HTMLDivElement>(null)
  const olbySpaceRef = useRef<HTMLDivElement>(null)
  const expandConnectionsRef = useRef<HTMLDivElement>(null)
  const fromOurBlogRef = useRef<HTMLDivElement>(null)
  const readyTogetStartedRef = useRef<HTMLDivElement>(null)
  const talentNewsletterRef = useRef<HTMLDivElement>(null)

  useUpdateHeader(empowerRef, HEADER_THEMES.PRIMARY_BRAND_BASE_ALT)
  useUpdateHeader(getStartedRef, HEADER_THEMES.PRIMARY_BRAND_BASE)
  useUpdateHeader(lifeChangingRef, HEADER_THEMES.SECONDARY_BRAND_BASE)
  useUpdateHeader(sayHelloRef, HEADER_THEMES.PRIMARY_BRAND_BASE)
  useUpdateHeader(rocketScienceRef, HEADER_THEMES.EXT_DEEP_BLUE)
  // useUpdateHeader(transparencyUnfoldedRef, HEADER_THEMES.EXT_DEEP_BLUE)
  useUpdateHeader(olbySpaceRef, HEADER_THEMES.PRIMARY_BRAND_BASE)
  useUpdateHeader(expandConnectionsRef, HEADER_THEMES.SECONDARY_BRAND_LOW)
  useUpdateHeader(fromOurBlogRef, HEADER_THEMES.NEUTRAL_BACKGROUND)
  useUpdateHeader(readyTogetStartedRef, HEADER_THEMES.HIGHLIGHT_ALT_BASE)
  useUpdateHeader(talentNewsletterRef, HEADER_THEMES.EXT_DEEP_BLUE)
  useCleanHeader()

  const { data } = useGetWebsiteTalentPageQuery({ input: { locale: Locale.En } })

  const posts = useMemo(() => {
    if (!data?.getWebsiteTalentPage?.data) {
      return []
    }
    const list = data?.getWebsiteTalentPage?.data.posts?.map(({ post }) => post)
    const formattedArticles = websiteFormatArticleList(list || [])
    return formattedArticles
  }, [data])

  return (
    <>
      <WebsiteSeo seo={SEO} />
      <EmpowerSection className={styles['empower-section']} ref={empowerRef} />
      <ForTalentsGetStarted ref={getStartedRef} />
      <LifeChangingOpportunities ref={lifeChangingRef} />
      <SayHelloSection ref={sayHelloRef} />
      <RocketScienceSection ref={rocketScienceRef} />
      <ForTalentTransparencyUnfolded ref={transparencyUnfoldedRef} />
      <ForTalentOlbySpace ref={olbySpaceRef} />
      <ExpandYourConnections ref={expandConnectionsRef} />
      <FromOurBlogSection posts={posts} ref={fromOurBlogRef} />
      <ReadyToSayHelloTalentSection ref={readyTogetStartedRef} />
      <TalentNewsletterSections ref={talentNewsletterRef} />
    </>
  )
}

export default ForTalent

ForTalent.getLayout = (page: ReactElement) => {
  return (
    <WebsiteLayout shouldChangeBgColor headerInitialTheme={HEADER_THEMES.PRIMARY_BRAND_BASE_ALT}>
      {page}
    </WebsiteLayout>
  )
}
